export default __webpack_public_path__ + "static/media/default_empty_logo.fb69f693.svg";